import { getEnviroment } from 'utils/getEnviroment';

export const isSSR = !global?.window;
export const { isDevelopment, isProduction, isTest } = getEnviroment();
